module.exports = __webpack_public_path__ + "img/at.1b360faf.svg";